// Páginas legales: /privacidad y /terminos
import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { COLORS } from './designSystem';
import { PhoneShell, useSafeBack } from './components';

const H = ({ title, back, testid }) => {
  const goBack = useSafeBack('/perfil');
  return (
    <header className="px-5 pt-6 pb-4 flex items-center gap-3">
      <button onClick={goBack} className="w-10 h-10 flex items-center justify-center rounded-full" style={{ backgroundColor: COLORS.surface }} data-testid={testid}><ChevronLeft size={22} color={COLORS.text} /></button>
      <h1 className="text-white text-xl font-extrabold">{title}</h1>
    </header>
  );
};

export const PrivacyPage = () => (
  <PhoneShell>
    <H title="Política de privacidad" testid="privacy-back" />
    <section className="px-5 pb-10 space-y-4 text-sm leading-relaxed" style={{ color: COLORS.textMuted }}>
      <p>En Clubbers nos tomamos tu privacidad en serio. Esta política describe qué datos recopilamos, para qué y cómo los protegemos.</p>
      <p><strong className="text-white">Datos que recopilamos</strong>: email, nombre y edad al registrarte; datos de compra para generar entradas y recibos; favoritos (eventos y salas) guardados en tu dispositivo.</p>
      <p><strong className="text-white">Para qué los usamos</strong>: gestionar tu cuenta, enviarte entradas y confirmaciones de compra, personalizar la selección de eventos según tu edad y preferencias.</p>
      <p><strong className="text-white">Terceros</strong>: Stripe (pagos) y Resend (email). No vendemos tus datos.</p>
      <p><strong className="text-white">Tus derechos</strong>: puedes acceder, corregir o eliminar tus datos contactando con nosotros en entradas@clubbers.site.</p>
    </section>
  </PhoneShell>
);

export const TermsPage = () => (
  <PhoneShell>
    <H title="Términos y condiciones" testid="terms-back" />
    <section className="px-5 pb-10 space-y-4 text-sm leading-relaxed" style={{ color: COLORS.textMuted }}>
      <p>Al usar Clubbers aceptas los siguientes términos.</p>
      <p><strong className="text-white">1. Entradas</strong>: la compra de una entrada da acceso al evento indicado, sujeto a las condiciones de la sala y a la edad mínima.</p>
      <p><strong className="text-white">2. Devoluciones</strong>: las entradas no son reembolsables salvo cancelación del evento por parte de la sala.</p>
      <p><strong className="text-white">3. Comportamiento</strong>: la sala puede denegar el acceso si no cumples sus normas o si no tienes la edad mínima.</p>
      <p><strong className="text-white">4. Datos</strong>: tratados conforme a la Política de privacidad.</p>
      <p><strong className="text-white">5. Cambios</strong>: nos reservamos el derecho a actualizar estos términos.</p>
    </section>
  </PhoneShell>
);
